// deadline 為 epoch 毫秒；null / 空值 / 非數字皆視為永不過期，只在「有效數字且已過」時阻擋
// 縱深防禦下寧可顯示也不誤擋有效公告，故髒值一律不阻擋
export const isAnnouncementExpired = (item, now = Date.now()) => {
  const deadline = Number(item?.deadline)
  return Number.isFinite(deadline) && deadline > 0 && deadline <= now
}
